import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class GameBackground extends Phaser.GameObjects.Container {
  constructor(scene, w, h) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this.cloudy = false;
    this.clouds = [];
    this.curWidth = w;
    this.curHeight = h;
  }

  updateSize(w,h) {
    this.curWidth = w;
    this.curHeight = h;
    this.setBounds(0,0,w,h);
    this.layoutBackground();

  };

  addBackgroundShape(color) {
    this.bgColor = color;
    if (!this.bgShape) this.bgShape = ABCyaPhaser.Graphics.addRect(0, 0, this.scene.mid.x * 2, this.mid.y * 2, this.bgColor, this, { x: 0, y: 0 });
  };

  addBackgroundImage(imageName) {

    this.bgImageName = imageName;
    if (this.bgImage) this.bgImage.destroy();

    this.bgImage = ABCyaPhaser.Images.addImage(0, 0, this.bgImageName, this).setOrigin(0, 0);
    this.bgImage.x = 0;
    this.bgImage.y = this.scene.mid.y * 2 - this.bgImage.getBounds().height;
  };

  setClouds(cloudy) {
    this.cloudy = cloudy;
  };

  layoutBackground() {

    if (this.bgImage) {
      this.bgImage.x = 0;
      this.bgImage.y = this.scene.mid.y * 2 - this.bgImage.getBounds().height;
    }
  };

  tick() {

    if (this.cloudy) {
      if (this.clouds.length > 0) {

        for (let i = 0; i < this.clouds.length; i++) {

          const cloud = this.clouds[i];
          cloud.x += cloud._velX;
          if (cloud.x > this.curWidth + 50) {
            cloud.destroy();
            this.clouds.splice(i,1);
            i--;
          }
        }
      }

      if (this.clouds.length < 4) {
        this.addNewCloud();
      }
    }
    else {
      if (this.clouds.length > 0) {
        while (this.clouds.length > 0) {
          this.clouds.shift().destroy();
        }
      }
    }

  };

  addNewCloud() {
    const cloud = ABCyaPhaser.Images.addImage(0, 0, `cloud-${Phaser.Math.Between(1,2).toString()}`, this).setOrigin(0, 0);
    cloud.x = this.clouds.length < 3 ? Phaser.Math.Between(0,this.curWidth) : (cloud.getBounds().width + 20) * -1;
    cloud.y = Phaser.Math.Between(0, this.curHeight / 3);
    cloud.scaleX = Phaser.Math.Between(50,120) / 100;
    cloud.scaleY = cloud.scaleX;
    cloud.alpha = Phaser.Math.Between(5,8) / 10;
    cloud._velX = Phaser.Math.Between(5,10) / 10;
    this.clouds.push(cloud);
  };
}